import { Schedule as ScheduleIcon } from "@mui/icons-material";
import { Button } from "@mui/material";

import { successGradientButtonSx } from "../../organisms/AddEventTimesModal/AddEventTimesModal.theme";

// User-facing strings
const STRINGS = {
  ADD_EVENT_TIMES: "Create",
} as const;

interface AddEventTimesButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export const AddEventTimesButton = ({ onClick, disabled }: AddEventTimesButtonProps) => {
  return (
    <Button
      disabled={disabled}
      fullWidth
      onClick={onClick}
      startIcon={<ScheduleIcon />}
      sx={{
        borderRadius: "12px",
        fontWeight: "bold",
        textTransform: "none",
        ...successGradientButtonSx,
      }}
      variant="contained"
    >
      {STRINGS.ADD_EVENT_TIMES}
    </Button>
  );
};
